// tslint:disable-next-line:max-line-length
export const MAIL_CONTENT_DE: string = 'Sehr geehrter Interessent.\nDanke das sie unseren OnlinePlanner genutzt haben. Sie werden in Kürze von uns\nkontaktiert um ihnen nach Bedarf und Wunsch eine optimale Beratung zu geben.\n\nVielen Dank ihr\nVertriebsteam.';
// tslint:disable-next-line:max-line-length
export const MAIL_CONTENT_EN: string = 'Dear prospective guest.\nThank you for using our OnlinePlanner. You will be contacted by us shortly to\nprovide you with an optimal consultation as when required.\n\nYours faithfully,\nSales team.';
export const EMAIL_PATTERN: RegExp = /(.+)@(.+){2,}\.(.+){2,}/;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/TextConstants.ts